import * as fromDatatype from '../../../datatype-library';

export class ReviewEligibilityDto {
    entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
}